import {
  ADVISOR_KEY,
  casesUrls,
  vdsUrls,
  VDS_KEY,
  VERSION,
} from "../../constants/ApiUrls";
import {
  getData,
  updateData,
  patchData,
} from "../../networkManager/NetworkManager";

export const getCasesList = async (id, search = "", queryString) => {
  return await getData(
    ADVISOR_KEY +
      VERSION +
      `${id}/${casesUrls.CASES_LIST}?searchString=${search}` +
      queryString
  );
};
export const getConsultantsList = async (role, bankId, branchId) => {
  return await getData(
    VDS_KEY +
      VERSION +
      `${vdsUrls.USERS}?Role=${encodeURIComponent(
        role
      )}&BankId=${bankId}&BranchId=${branchId}`
  );
};
export const getCase = async (userId, id) => {
  return await getData(
    ADVISOR_KEY + VERSION + `${userId}/${casesUrls.CASE}?caseId=${id}`
  );
};
export const updateCaseList = (data, id) => {
  return updateData(
    ADVISOR_KEY + VERSION + `${id}/${casesUrls.CASES_LIST}`,
    data
  );
};
export const viewCase = (id, caseId) => {
  return patchData(ADVISOR_KEY + VERSION + `${id}/${casesUrls.CASE}/${caseId}`);
};
